import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { NoInfo } from "../components/structure/NoInfo";

class ProductList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prodURL: "",
    };
  }

  checkForCustomUrls(prod) {
    const { urlsByProduct } = this.props;
    let customUrls = { hasUrl: false, urlList: [] };

    if (urlsByProduct && urlsByProduct.length > 0) {
      urlsByProduct.forEach((item) => {
        item.productIdList.forEach((id) => {
          if (id === prod.productId) {
            customUrls.hasUrl = true;
            customUrls.urlList.push(item);
          }
        });
      });
    }

    return customUrls;
  }

  checkForCustomBanners(prod) {
    const { bannersByProduct } = this.props;
    let customBanners = { hasBanner: false, bannerList: [] };

    if (bannersByProduct && bannersByProduct.length > 0) {
      bannersByProduct.forEach((item) => {
        item.productIdList.forEach((id) => {
          if (id === prod.productId) {
            customBanners.hasBanner = true;
            customBanners.bannerList.push(item);
          }
        });
      });
    }

    return customBanners;
  }

  render() {
    const {
      prodList,
      salesGroups,
      handleProductClick,
      handleIframeClick,
      handleUrlClick,
      handleBannerClick,
    } = this.props;
    const prodHTML = [];

    //CREATE LIST OF PRODUCTS
    salesGroups.forEach((sg) => {
      prodList.forEach((prod) => {
        let customUrls = this.checkForCustomUrls(prod);
        let customBanners = this.checkForCustomBanners(prod);

        if (prod.salesGroupIds.includes(sg.id)) {
          prodHTML.push(
            <li className="productItem" key={`prodId${prod.productId}`}>
              <img className="productImg" src={prod.image} alt="" />
              <p className="prodTitle">{prod.shortName}</p>
              <p>{sg.name}</p>
              <button
                className="btn linkButtons"
                onClick={() => handleProductClick(prod, sg.id)}
              >
                <span className="glyphicon glyphicon-link"></span>
                <span>Create Link</span>
              </button>
              <br />

              <button
                className="btn linkButtons"
                style={{ marginTop: 5 }}
                onClick={() => handleIframeClick(prod, sg.id)}
                disabled={prod.productCategory.general ? false : true}
              >
                <span className="glyphicon glyphicon-paperclip"></span>
                <span>Create iframe</span>
              </button>

              <br />

              <button
                className="btn linkButtons"
                style={{ marginTop: 5 }}
                onClick={() => handleUrlClick(prod, sg.id, customUrls.urlList)}
                disabled={!customUrls.hasUrl}
              >
                <span className="glyphicon glyphicon-link"></span>
                <span>Custom Links</span>
              </button>

              <br />

              <button
                className="btn linkButtons"
                style={{ marginTop: 5 }}
                onClick={() =>
                  handleBannerClick(prod, sg.id, customBanners.bannerList)
                }
                disabled={!customBanners.hasBanner}
              >
                <span className="glyphicon glyphicon-link"></span>
                <span>Create Banner</span>
              </button>
            </li>
          );
        }
      });
    });

    return (
      <Fragment>
        {prodHTML && prodHTML.length > 0 ? (
          <div>
            <ul className="productList" style={{ listStyleType: "none" }}>
              {prodHTML}
            </ul>
          </div>
        ) : (
          <NoInfo displayMsg="There are no products available at this time" />
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { salesGroups, affiliates, languages, items } = state;

  return {
    salesGroups: salesGroups && salesGroups.salesGroupIdList,
    externalAffId: affiliates && affiliates.externalAffId,
    languages: languages && languages.languageList,
    urlsByProduct: items && items.urlsByProduct,
    bannersByProduct: items && items.bannersByProduct,
  };
};

export default connect(mapStateToProps)(ProductList);
